import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashBoard from "pages/master/dashboard"
import WorkSpace from "pages/master/workspace"
import WorkSpaceDetail from "pages/master/workspace/detail"
import WorkSpaceSetupWebsite from "pages/master/workspace/setup-website"
import PackagesPage from "pages/master/packages"
import { useAuth } from "contexts/auth"

const PageRoutes = () => {
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState([]);
  var defaultPage = <DashBoard></DashBoard>;



  const allRouters = [
     { element: <Route path="workspace" element={<WorkSpace></WorkSpace>} />, permission: "" },
     { element: <Route path="workspace/:w_id" element={<WorkSpaceDetail />} />, permission: "" },
      { element: <Route path="workspace/:w_id/setup-website" element={<WorkSpaceSetupWebsite />} />, permission: "" },
     { element: <Route path="packages" element={<PackagesPage></PackagesPage>} />, permission: "" },

    { element: <Route path="*" element={defaultPage} />, permission: "" },
  ]









  React.useEffect(() => {


    var permissions = user.permissions ?? [];

    var items = [...allRouters];

    setRoutes(items);
  }, [user])





















  return (
    <Routes>

      {routes.map(x => {

        var element = x?.element;
        return element;

      })}
     
    </Routes>
  );
};

export default React.memo(PageRoutes);
